const baseURL = 'https://hotelelpallar.komerzy.com/';

export default baseURL;
